// extracted by mini-css-extract-plugin
export default {"main":"iconLink_main__rNSVO","hasNotification":"iconLink_hasNotification__uZHuM"};